import enquireJs from 'enquire.js'
import userManager from '@/user/UserManager'
import { reactive } from 'vue'

export function throttle(fn: Function, delay: number) {
  let valid = true
  return function () {
    if (!valid) {
      return false
    }
    valid = false
    setTimeout(() => {
      fn()
      valid = true
    }, delay)
  }
}

export const queryMedia = (callback: any) => {
  enquireJs
    .register(`screen and (min-width: 1600px)`, () => {
      callback('xxl')
    })
    .register(`screen and (min-width: 1200px) and (max-width: 1600px)`, () => {
      callback('xl')
    })
    .register(`screen and (min-width: 992px) and (max-width: 1200px)`, () => {
      callback('lg')
    })
    .register(`screen and (min-width: 768px) and (max-width: 992px)`, () => {
      callback('md')
    })
    .register(`screen and (min-width: 576px) and (max-width: 768px)`, () => {
      callback('sm')
    })
    .register(`screen and (max-width: 576px)`, () => {
      callback('xs')
    })
}

export const AxixValueFormatter = (value: any) => {
  if (value >= 1000000000) {
    return Math.round(value / 1000000000) + 'B'
  } else if (value >= 1000000) {
    return Math.round(value / 1000000) + 'M'
  } else if (value >= 1000) {
    return Math.round(value / 1000) + 'K'
  } else {
    return value
  }
}

export const AxixValueFormatterFixed = (value: any, fix: number) => {
  if (value >= 1000000000) {
    return (value / 1000000000).toFixed(fix) + 'B'
  } else if (value >= 1000000) {
    return (value / 1000000).toFixed(fix) + 'M'
  } else if (value >= 1000) {
    return (value / 1000).toFixed(fix) + 'K'
  } else {
    return value
  }
}

// 千分位格式化
export const toThousands = (number: number | string) => {
  var numString = (number || 0).toString(),
    result = ''
  const numberArr = numString.split('.')
  let int = numberArr[0]
  const reg = /\B(?=(\d{3})+(?!\d))/g

  result = int.replace(reg, ',')

  if (numberArr[1]) {
    result = result + '.' + numberArr[1]
  }
  return result
}

// 序列化 url search
export const queryString = (search: string) => {
  let res: any = {}
  const searchPart = search.split('?')[1]

  if (searchPart) {
    decodeURI(searchPart)
      .split('&')
      .map((item) => {
        const arr: string[] = item.split('=')
        res[arr[0]] = decodeURIComponent(arr[1])
      })
  }

  return res
}

type exportConfig = {
  url: string
  method?: 'get' | 'POST'
  target?: '_self' | '_blank'
  params: Record<string | number | symbol, any>
}
// excel 导出
export const ExcelExport = (config: exportConfig) => {
  const { url, method, target, params } = config

  const turnForm = document.createElement('form')

  document.body.appendChild(turnForm)

  // 默认 post , 新页面打开
  turnForm.method = method || 'post'
  turnForm.target = target || '_blank'
  turnForm.action = 'https://a-webapi.didaadmin.com' + url
  //turnForm.action='http://localhost:40876/'+ url;

  //创建隐藏表单
  for (const item in params) {
    const newElement = document.createElement('input')
    newElement.setAttribute('type', 'hidden')
    newElement.setAttribute('name', item)
    newElement.setAttribute('value', params[item])
    turnForm.appendChild(newElement)
  }

  turnForm.submit()
}

var rbracket = /\[\]$/,
  rCRLF = /\r?\n/g,
  op = Object.prototype,
  ap = Array.prototype,
  aeach = ap.forEach,
  ostring = op.toString

function isFunction(it) {
  return ostring.call(it) === '[object Function]'
}

function isArray(it) {
  return ostring.call(it) === '[object Array]'
}

function isObject(it) {
  return ostring.call(it) === '[object Object]'
}

/**
 * @description 另一种导出，ParamClass.param 对标旧版 $.param
 * @return {*}
 */
class ParamClass {
  constructor() { }

  buildParams(prefix, obj, traditional, add) {
    var name
    let _this = this
    if (isArray(obj)) {
      // Serialize array item.
      aeach.call(obj, function (v, i) {
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v)
        } else {
          // Item is non-scalar (array or object), encode its numeric index.
          _this.buildParams(
            prefix + '[' + (typeof v === 'object' && v != null ? i : '') + ']',
            v,
            traditional,
            add
          )
        }
      })
    } else if (!traditional && isObject(obj)) {
      // Serialize object item.
      for (name in obj) {
        this.buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
      }
    } else {
      // Serialize scalar item.
      add(prefix, obj)
    }
  }

  // Serialize an array of form elements or a set of
  // key/values into a query string
  param(a, traditional?) {
    var prefix
    var s = []
    var add = function (key, valueOrFunction) {
      // If value is a function, invoke it and use its return value
      var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction

      s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value)
    }

    // If an array was passed in, assume that it is an array of form elements.
    if (isArray(a)) {
      // Serialize the form elements
      aeach.call(a, function (item) {
        add(item.name, item.value)
      })
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in a) {
        this.buildParams(prefix, a[prefix], traditional, add)
      }
    }

    // Return the resulting serialization
    return s.join('&')
  }
}

export const paramClass = new ParamClass()

// 将Object 转成 Url search
export const cptSearhStr = (obj) => {
  let res = []
  for (let key in obj) {
    res.push(`${key}=${obj[key]}`)
  }
  return res.join('&')
}

export const buildFormData = (obj) => {
  const bodyFormData = new FormData()

  for (let key in obj) {
    bodyFormData.append(key, obj[key])
  }

  return bodyFormData
}

export function openWindow(urlParam, type) {
  var url = urlParam.slice(0, urlParam.indexOf('?'))
  var param = urlParam.slice(urlParam.indexOf('?') + 1).split('&')
  var tempForm = document.createElement('form')
  tempForm.id = 'tempForm1'
  tempForm.method = 'post'
  tempForm.action = url
  tempForm.target = type
  var hash
  for (var i = 0; i < param.length; i++) {
    hash = param[i].split('=')
    var hideInput = document.createElement('input')
    hideInput.type = 'hidden'
    hideInput.name = hash[0]
    hideInput.value = hash[1]
    tempForm.appendChild(hideInput)
  }
  if (document.all) {
    // 兼容不同浏览器
    tempForm.attachEvent('onsubmit', function () { }) //IE
  } else {
    tempForm.addEventListener('submit', function () { }, false) //firefox
  }
  document.body.appendChild(tempForm)
  if (document.all) {
    // 兼容不同浏览器
    tempForm.fireEvent('onsubmit')
  } else {
    tempForm.dispatchEvent(new Event('submit'))
  }
  tempForm.submit()
  document.body.removeChild(tempForm)
}

export const generateNumberAarray = (end: number, start: number = 1) => {
  return Array.from(new Array(end + 1).keys()).slice(start)
}

export const isFromDCCenter = (): boolean => {
  return location.href.indexOf('DCCenter') > -1
}

// 从 url 上获取参数来初始化 formState
export const GetSearchReactive = (params = {}) => {
  const searchObj = queryString(window.location.search)
  console.log('searchObj', searchObj)
  Object.keys(searchObj).forEach((key) => {
    if (params.hasOwnProperty(key)) {
      params[key] = searchObj[key]
    }
  })
  return params
}

// 处理后端返回 arraybuffer 生产 Excel
export const ExprotResp = (data: ArrayBuffer, fileName: string) => {
  // 处理返回的文件流
  var blob = new Blob([data], {
    type: 'application/msword;charset=utf-8'
  })
  fileName += '.xlsx'
  var alink = document.createElement('a')
  var url = window.URL.createObjectURL(blob)
  alink.href = url
  alink.download = fileName
  var body = document.getElementsByTagName('body')[0]
  body.appendChild(alink)
  alink.click()
  body.removeChild(alink)
  window.URL.revokeObjectURL(url)
}
